import { IChartInfo } from "../../common/interfaces/chart.interface";
import { IUsersOverview } from "../../common/interfaces/user.interface";
import { get } from "../utilities/http";
import { USERS_CHART_INFO, USERS_OVERVIEW } from "../utilities/urls";

export function getUsersOverview(): Promise<IUsersOverview> {
  return get(USERS_OVERVIEW);
}

export function getUsersChartInfo(): Promise<IChartInfo> {
  return get(USERS_CHART_INFO);
}
